import { FieldLabel, Input, SelectMenu } from '@postscript/components';
import { DiscountValueQualifier } from 'components/brand/offers/types';
import styled from 'styled-components';

const ValueRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(120px, 1fr);
  gap: var(--spacing-2);
`;

const QUALIFIERS = [
  { label: 'Exactly', value: DiscountValueQualifier.EXACTLY },
  { label: 'Up to', value: DiscountValueQualifier.UP_TO },
];

interface StructuredDiscountInputProps {
  id: string;
  amount: string;
  qualifier: DiscountValueQualifier;
  prefix?: string;
  suffix?: string;
  onAmountChange: (amount: string) => void;
  onQualifierChange: (qualifier: DiscountValueQualifier) => void;
  error?: string;
}

export const StructuredDiscountInput = ({
  id,
  amount,
  qualifier,
  prefix,
  suffix,
  onAmountChange,
  onQualifierChange,
  error,
}: StructuredDiscountInputProps): JSX.Element => {
  const amountId = `${id}-amount`;
  const labelId = `${id}-label`;

  return (
    <div>
      <FieldLabel id={labelId} htmlFor={amountId} required>
        Offer value
      </FieldLabel>
      <ValueRow>
        <Input
          id={amountId}
          type="number"
          min="0"
          step="any"
          value={amount}
          prefix={prefix}
          suffix={suffix}
          onChange={(event) => onAmountChange(event.target.value)}
          error={Boolean(error)}
          errorMessage={error}
        />
        <SelectMenu
          id={`${id}-qualifier`}
          labelledBy={labelId}
          options={QUALIFIERS}
          value={QUALIFIERS.find(({ value }) => value === qualifier)}
          isClearable={false}
          onChange={(option) =>
            onQualifierChange((option as typeof QUALIFIERS[number]).value)
          }
        />
      </ValueRow>
    </div>
  );
};
